export const initialVaultState = {
  height: 85,
  walls: [
    {sleeves: [], blockOuts: [], drainages: [], groundings: [], cRails: []},
    {sleeves: [], blockOuts: [], drainages: [], groundings: [], cRails: []},
    {sleeves: [], blockOuts: [], drainages: [], groundings: [], cRails: []},
    {sleeves: [], blockOuts: [], drainages: [], groundings: [], cRails: []}
  ]
}

